module.exports = __webpack_public_path__ + "img/no-data.d522c859.jpg";